import type { ChartMeta, ChartMetaDTO } from '@/features/chartsView';
import { baseApi, getErrorMessage } from '@/shared/api';
import type { CohortDataResponse } from '../model/types';
import type { GetCohortDataParams } from './types';

export const getMeta = async (): Promise<ChartMeta> => {
  const { data, error } = await baseApi.functions.invoke<{
    cohortMarketingPerformanceMeta: ChartMetaDTO;
  }>('getComparisonViewMeta');

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return data.cohortMarketingPerformanceMeta;
};

export const getCohortData = async ({
  split,
  metrics,
  dateScale,
  dateRange,
  probabilisticAttribution,
  lifetime,
  dimensionsFilters,
  metricsFilters,
}: GetCohortDataParams) => {
  const { data, error } = await baseApi.functions.invoke<CohortDataResponse>(
    'getComparisonViewCohortData',
    {
      body: {
        split,
        metrics,
        dateScale,
        dateRange,
        probabilisticAttribution,
        lifetime,
        dimensionsFilters,
        metricsFilters,
      },
    },
  );

  if (!data) {
    const errorMessage = getErrorMessage(error);

    throw new Error(errorMessage);
  }

  return data;
};
